import React from 'react';
import { connect } from 'react-redux';
import { StoreState } from 'state/types';
import {
  BOX_EMPLOYEE_DASHBOARD_EVENTS_UPDATE_FORM_FILTERS,
  getFiltersForm,
} from 'state/EmployeeDashboard/Events';
import View, { Props as ViewProps } from './view';
import { getLangPreferences } from 'state/Account';

type StateProps = Pick<ViewProps, 'formData' | 'langPreferences'>;
type DispatchProps = Pick<ViewProps, 'onChange'>;
type Props = StateProps & DispatchProps;

const CustomFiltersComponent = (props: Props) => <View {...props} />;

const mapStateToProps = (state: StoreState): StateProps => ({
  formData: getFiltersForm(state),
  langPreferences: getLangPreferences(state),
});

const mapDispatchToProps: DispatchProps = {
  onChange: BOX_EMPLOYEE_DASHBOARD_EVENTS_UPDATE_FORM_FILTERS,
};

export const CustomFilters = connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomFiltersComponent);
